import { render, staticRenderFns } from "./firmOrder.vue?vue&type=template&id=603800c9"
import script from "./firmOrder.vue?vue&type=script&lang=ts"
export * from "./firmOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports